
import React, {useState,useEffect,useCallback} from 'react'
import useForm from './useForm';
import Modal from '../Modal/Modal';
// import Modal from '@material-ui/core/Modal';
import dataServices from "../../common/dataServices";
import Attach from '../../../dist/assets/Attach.png';

const Form = React.memo(props =>{

   const stateSchema = {
     Fields:{
          Title: {value: 'הודעה מדף צור קשר',error:''},
          MODFirstName: { value: '',error:'' },
          MODFamilyName: { value: '',error:''},
          MODID: { value: '',error:''},
          MODEMail: { value: '',error:''},
          MODPhoneNumber: { value: '',error:''},
          MODComments: { value: '',error:''},
     },
    MailTo: props.mailTo,
    //todo MailFormat{}
  };
  const [showModal,setShowModal] = useState(false);
  const [isSucc,setIsSucc] = useState(false);
  const [loading,setLoading]= useState(false);

  // Disable button in initial render.
  useEffect(() => {
    setShowModal(false);
  }, []);



// Define your validationStateSchema
  // Note: validationStateSchema and stateSchema property
  // should be the same in-order validation works!
  const validationStateSchema = {
    Title: { },
    MODFirstName: { 
      required: true,
      label:'שם פרטי',
      validator: {
        regEx: /^[a-zA-Z\u0590-\u05ff]+$/,
        error: 'שם פרטי לא תקין. יש להזין רק אותיות.',
      },
    },
    MODFamilyName: {
      required: true,
      label:'שם משפחה',
      validator: {
        regEx: /^[a-zA-Z\u0590-\u05ff]+$/,
        error: 'שם משפחה לא תקין. יש להזין רק אותיות',
      },
    },
    MODID: {
      required: true,
      label:'מספר תיק/ ת"ז',
      validator: {
        regEx: /^([0-9\b]{6,9})+$/,
        error: 'שדה תעודת זהות שגוי. יש להזין רק מספרים',
      },
    },
    MODPhoneNumber: {
      required: true,
      label:'טלפון',
      validator: {
        regEx: /^(,?\w{9,})+$/,
        error: 'תבנית טלפון לא תקינה',
      },
    },
    MODEMail: {
        required: true,
        label:'דוא"ל',
        validator: {
          regEx:  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          error: 'כתובת מייל לא תקנית',
        },
      },
      MODComments: {
        required: true,
        label:'תוכן הפנייה',
      },
    // time: {
    //     required: true,
    //     validator: {
    //       regexp: /^(([0-1]?[0-9])|([2][0-3])):([0-5]?[0-9])(:([0-5]?[0-9]))?$/,
    //       error: 'Not valid time.',
    //     },
    //   },
  };


   function onSubmitForm(state) {
    setLoading(true);
    const res =  dataServices.setContactUsData(props.siteUrl,state).then(response=>{
      setIsSucc(true);
      setShowModal(true);
      setLoading(false);
   })
   .catch((error)=>
   {
      setIsSucc(false);
      setShowModal(true);
      setLoading(false);
   });
  };
  


  function handleOnClose (){
      setShowModal(false);
    }

const { state, handleOnChange, handleOnSubmit, disable } = useForm(
    stateSchema,
    validationStateSchema,
    onSubmitForm,
  );
const errorStyle = {
    color: 'red',
    fontSize: '14px',
  };
return (
    <div>
     
       {loading &&
       <div className="centerIcon">
          <i className="fas fa-spinner fa-spin"></i>
        </div>
        }
        <Modal  show={showModal} isSucc={isSucc}  onClose={handleOnClose}/>
        <div className="fieldDiv">
            <img className="attach_img" src={Attach} alt=""/>
            <h2>טופס פניות הציבור</h2>
      </div>
      <form onSubmit={handleOnSubmit}>
        <div>כל השדות בטופס הן חובה. רק לאחר מילויין ניתן שלוח את הטופס</div>
        <div className="fieldDiv ">
          <label htmlFor="MODFirstName">
            * {validationStateSchema["MODFirstName"].label}
            <input
              type="text"
              name="MODFirstName"
              id="MODFirstName"
              value={state.Fields["MODFirstName"].value}
              onChange={handleOnChange}
              placeholder="שם פרטי"
              aria-required={validationStateSchema["MODFirstName"].required}
              aria-invalid={state.Fields["MODFirstName"].error ? "true" : null}
            />
          </label> 
          {state.Fields["MODFirstName"].error && <p style={errorStyle} aria-describedby="MODFirstName">{state.Fields["MODFirstName"].error} </p>}
        </div>
        <div className="fieldDiv">
          <label htmlFor="MODFamilyName">
            * {validationStateSchema["MODFamilyName"].label}
            <input
              type="text"
              name="MODFamilyName"
              id="MODFamilyName"
              value={state.Fields["MODFamilyName"].value}
              onChange={handleOnChange}
              placeholder="שם משפחה"
              aria-required={validationStateSchema["MODFamilyName"].required}
              aria-invalid={state.Fields["MODFamilyName"].error ? "true" : null}
            />
          </label>
          {state.Fields["MODFamilyName"].error && <p style={errorStyle} aria-describedby="MODFamilyName">{state.Fields["MODFamilyName"].error}</p>}
        </div>
       
        <div className="fieldDiv">
          <label htmlFor="MODID">
             * {validationStateSchema["MODID"].label}
            <input
              type="text"
              name="MODID"
              id="MODID"
              value={state.Fields["MODID"].value}
              onChange={handleOnChange}
              placeholder='מספר תיק/ ת"ז'
              aria-required={validationStateSchema["MODID"].required}
              aria-invalid={state.Fields["MODID"].error ? "true" : null}
            />
          </label>
          {state.Fields["MODID"].error && <p style={errorStyle} aria-describedby="MODID">{state.Fields["MODID"].error}</p>}
        </div>
        <div className="fieldDiv">
          <label htmlFor="MODEMail">
          * {validationStateSchema["MODEMail"].label}
            <input
              type="mail"
              name="MODEMail"
              id="MODEMail"
              value={state.Fields["MODEMail"].value}
              onChange={handleOnChange}
              placeholder='דוא"ל'
              aria-required={validationStateSchema["MODEMail"].required}
              aria-invalid={state.Fields["MODEMail"].error ? "true" : null}
            />
          </label>
          {state.Fields["MODEMail"].error && <p style={errorStyle} aria-describedby="MODEMail">{state.Fields["MODEMail"].error}</p>}
        </div>
        <div className="fieldDiv">
          <label htmlFor="MODPhoneNumber">
            * {validationStateSchema["MODPhoneNumber"].label}
            <input
              type="text"
              name="MODPhoneNumber"
              id="MODPhoneNumber"
              value={state.Fields["MODPhoneNumber"].value}
              onChange={handleOnChange}
              placeholder="טלפון"
              aria-required={validationStateSchema["MODPhoneNumber"].required}
              aria-invalid={state.Fields["MODPhoneNumber"].error ? "true" : null}
            />
          </label>
          {state.Fields["MODPhoneNumber"].error && <p style={errorStyle} aria-describedby="MODPhoneNumber">{state.Fields["MODPhoneNumber"].error}</p>}
        </div>
        <div className="fieldDiv">
          <label htmlFor="MODComments">
          *  {validationStateSchema["MODComments"].label}
            <textarea
              rows="8"
              id="MODComments"
              name="MODComments"
              value={state.Fields["MODComments"].value}
              onChange={handleOnChange}
              aria-required={validationStateSchema["MODComments"].required}
              aria-invalid={state.Fields["MODComments"].error ? "true" : null}
              placeholder='תוכן הפנייה'
            />
          </label>
       
          {state.Fields["MODComments"].error && <p style={errorStyle} aria-describedby="MODComments">{state.Fields["MODComments"].error}</p>}
        </div>
        {/* <div className="submitWrap"> */}
        <button type="submit" name="submit" disabled={disable} className="submitBut">
          <span>שלח פנייה</span>
          <i className="fa fa-arrow-left"></i>
        </button>
        {/* </div> */}
      </form>
    </div>
  );
});
export default Form;

